// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Origens_ListaOrigensResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /config/origens/listaOrigens
 *
 * Returns the full list of origens (with translated origem_nome and
 * controller-injected franquia name). Per-row shape: Origens_OrigemRow.
 *
 * @see Origens_model::retornaOrigens()
 */
import type { Origens_OrigemRow } from './Origens_OrigemRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Origens_ListaOrigensResponseDados = Origens_OrigemRow[];

export type Origens_ListaOrigensResponse = ApiResponse<Origens_ListaOrigensResponseDados>;

registerResponseContract('Origens_ListaOrigensResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      origem_id:          { type: 'number',  required: true },
      origem_nome:        { type: 'string',  required: true },
      origem_franquia_id: { type: 'number',  required: true },
      franquia:           { type: 'string',  required: false },
    },
  },
})
